import { useEffect } from 'react';
import { Projects, ContactCTA } from '@ui/sections';
import { projects } from '@content/projects';
import { site } from '@content/site';
import { projectsCopy, contactCtaCopy } from '@content/ui-strings';

export function ProjectsRoute() {
  useEffect(() => {
    document.title = `Projects · ${site.seo.title.split(' · ')[0] ?? 'Alison Haire'}`;
  }, []);

  return (
    <>
      <Projects items={projects.items} copy={projectsCopy} />
      <ContactCTA calendlyHref={site.links['calendly'] ?? '#'} copy={contactCtaCopy} />
    </>
  );
}
